/** The side menu and top bar of the console (moved here on 27/10/2026). Twin of `it.ts`. */
export default {
  barra: {
    titolo: 'Operator Console',
    piattaforma: 'PLATFORM',
    apri_menu: 'Open the menu',
    stringi: 'Collapse the menu',
    allarga: 'Expand the menu',
    stringi_tasti: 'Collapse the menu ({{tasti}})',
    allarga_tasti: 'Expand the menu ({{tasti}})',
  },
  sezioni: {
    piattaforma: 'Platform',
    acquisizione: 'Acquisition',
    personale: 'Personal',
    assistenza: 'Support',
  },
  voci: {
    tenants: 'Tenants',
    catalogo: 'Catalogue',
    anagrafe: 'Registry',
    pricing: 'Pricing',
    consumi: 'Usage',
    consegne: 'To deliver',
    motori_ai: 'AI engines',
    permessi: 'Building permits',
    fornitori: 'Suppliers',
    listini_fornitori: 'Supplier price lists',
    app_mobile: 'Mobile apps',
    realta_aumentata: 'Augmented reality',
    documentazione: 'Documentation',
    audit: 'Audit log',
    aziende: 'Companies',
    questionari: 'Questionnaires',
    yuma_sito: 'Yuma on the site',
    partner: 'Partners',
    rete: 'Contact network',
    ticket: 'Tickets',
  },
  piede: {
    esci: 'Sign out',
    versione: 'Console v1.0',
  },
} as const;
